(function () {
  var jouleThemeConfig = function ($mdThemingProvider) {
    $mdThemingProvider.definePalette('joule-primary', {
      '50': 'e8f1f9',
      '100': 'c6dcef',
      '200': 'a1c5e5',
      '300': '7baeda',
      '400': '5e9cd2',
      '500': '428bca',
      '600': '3c83c5',
      '700': '3378bd',
      '800': '2b6eb7',
      '900': '1d5bab',
      'A100': 'e3eeff',
      'A200': 'b0d0ff',
      'A400': '7db2ff',
      'A700': '63a3ff',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        '300',
        '400',
        'A100',
        'A200',
        'A400',
        'A700'
      ],
      'contrastLightColors': [
        '500',
        '600',
        '700',
        '800',
        '900'
      ]
    });

    $mdThemingProvider.definePalette('joule-accent', {
      '50': 'ebf7fb',
      '100': 'ceecf5',
      '200': 'ade0ef',
      '300': '8cd3e8',
      '400': '74c9e3',
      '500': '5bc0de',
      '600': '53bada',
      '700': '49b2d5',
      '800': '40aad1',
      '900': '2f9cc8',
      'A100': 'ffffff',
      'A200': 'd9f3ff',
      'A400': 'a6e4ff',
      'A700': '8cdcff',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        '300',
        '400',
        '500',
        '600',
        '700',
        '800',
        '900',
        'A100',
        'A200',
        'A400',
        'A700'
      ],
      'contrastLightColors': []
    });

    $mdThemingProvider.definePalette('joule-warn', {
      '50': 'f9e9e9',
      '100': 'efc8c8',
      '200': 'e5a4a4',
      '300': 'da7f7f',
      '400': 'd26363',
      '500': 'ca4848',
      '600': 'c54141',
      '700': 'bd3838',
      '800': 'b73030',
      '900': 'ab2121',
      'A100': 'ffe5e5',
      'A200': 'ffb3b3',
      'A400': 'ff8080',
      'A700': 'ff6666',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        '300',
        '400',
        'A100',
        'A200',
        'A400',
        'A700'
      ],
      'contrastLightColors': [
        '500',
        '600',
        '700',
        '800',
        '900'
      ]
    });

    $mdThemingProvider.theme('joule')
      .primaryPalette('joule-primary')
      .accentPalette('joule-accent')
      .warnPalette('joule-warn');
  };

  jouleThemeConfig.$inject = ['$mdThemingProvider'];
  angular.module('ecap').config(jouleThemeConfig);

  var jouleThemeRun = function ($rootScope) {
    if (!$rootScope.$themes) {
      $rootScope.$themes = {};
    }
    $rootScope.$themes['ecapwest'] = {
      primaryColor: '#233967',
      accentColor: '#1d84f5'
    };
  };

  jouleThemeRun.$inject = ['$rootScope'];
  angular.module('ecap').run(jouleThemeRun);
})();
